import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {AutopayThresholdExceededPanel} from "./AutopayThresholdExceededPanel";
import {Messages} from "../../../../Messages";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {iFrameConnection} from "../../../../services/IFrameConnection";
import {IFrameMessages} from "../../../../../blink-sdk/messaging/IFrameMessages";


export class AutopayDisabledPanel extends AutopayThresholdExceededPanel {
    getDefaultOptions() {
        return Object.assign({}, super.getDefaultOptions(), {
            text: Messages.autopayDisabled,
            linkText: Messages.autopayDisabledLink,
        });
    }

    getLink() {
        return (
            <Link className={this.styleSheet.updateLimit} onClick={() => this.enableAutopay()}>
                {this.options.linkText}
            </Link>
        );
    }

    enableAutopay() {
        iFrameConnection.sendToSDK(IFrameMessages.SHOW_AUTOPAY);
    }
}
